module.exports = __webpack_public_path__ + "static/media/product-screen-3.d01d46af.png";